/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-02-29 10:59:14
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-11 15:56:24
 * @FilePath: /chaoyongtuan/src/menus/contentLibray.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const contentLibray = [
	{
		path: '/libray',
		component: null,
		name: '内容库',
		id: 5,
		parentId: 0,
		keepAlive: false,
		showBread: false,
		visible: true,
		useTemplate: false,
		redirect: '/libray/local',
		children: [
			{
				path: 'local',
				redirect: '/libray/local/list',
				component: null,
				name: '本地素材库',
				parentId: 5,
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
				children: [
					{
						component: 'contentLibray/LocalMaterial/list/LocalMaterial.vue',
						icon: 'system',
						id: 70,
						keepAlive: false,
						name: '监控配置',
						parentId: 61,
						path: 'list',
						showBread: true,
						useTemplate: false,
						visible: true,
					},
				],
			},
		],
	},
];
export default contentLibray;